export const OthersIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_284_15629)">
      <path
        d="M0 1.75V6.41667H6.41667V0H1.75C1.28587 0 0.840752 0.184374 0.512563 0.512563C0.184374 0.840752 0 1.28587 0 1.75ZM5.25 5.25H1.16667V1.75C1.16667 1.59529 1.22812 1.44692 1.33752 1.33752C1.44692 1.22812 1.59529 1.16667 1.75 1.16667H5.25V5.25Z"
        fill="currentColor"
      />
      <path
        d="M0 12.2507C0 12.7148 0.184374 13.1599 0.512563 13.4881C0.840752 13.8163 1.28587 14.0007 1.75 14.0007H6.41667V7.58398H0V12.2507ZM1.16667 8.75065H5.25V12.834H1.75C1.59529 12.834 1.44692 12.7725 1.33752 12.6631C1.22812 12.5537 1.16667 12.4054 1.16667 12.2507V8.75065Z"
        fill="currentColor"
      />
      <path
        d="M7.5835 7.58398V14.0007H12.2502C12.7143 14.0007 13.1594 13.8163 13.4876 13.4881C13.8158 13.1599 14.0002 12.7148 14.0002 12.2507V7.58398H7.5835ZM12.8335 12.2507C12.8335 12.4054 12.772 12.5537 12.6626 12.6631C12.5532 12.7725 12.4049 12.834 12.2502 12.834H8.75016V8.75065H12.8335V12.2507Z"
        fill="currentColor"
      />
      <path
        d="M9.91683 6.41732H11.0835V4.08398H13.4168V2.91732H11.0835V0.583984H9.91683V2.91732H7.5835V4.08398H9.91683V6.41732Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_284_15629">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
